import {Api} from "./api";

const BRAND = process.env.REACT_APP_BRAND;
const COUNTRY = 'de';


class CustomerInfoProvider {

    constructor() {
        this.cache = {};
    }

    static createPayload(data) {

        // todo remove after clarification with webCALC

        data.webCalc = {
            yearlyGeneralAmount: 36500,
            yearlyAdministrationAmount: 36500,
            distributionAmount: 36500
        };

        if (!data.webCalc) {
            throw new Error('Failed to create customer information request due to missing webCALC information');
        }

        return {
            country: COUNTRY,
            brand: BRAND,
            customerData: {
                salutation: data.salutation,
                title: data.title,
                firstName: data.firstName,
                lastName: data.lastName,
                birthName: data.maidenName || '',
                addresses: [
                    {
                        city: data.city,
                        countryCode: data.country,
                        houseNumber: data.housenumber,
                        street: data.street,
                        zipCode: data.postcode
                    },
                    ...(!data.prevstreet ? [] : [{
                        city: data.prevcity,
                        countryCode: data.prevcountry,
                        houseNumber: data.prevhousenumber,
                        street: data.prevstreet,
                        zipCode: data.prevpostcode
                    }])
                ]
            },
            financialProduct: {
                staticCosts: {
                    yearlyGeneralAmount: data.webCalc.yearlyGeneralAmount,
                    yearlyAdministrationAmount: data.webCalc.yearlyAdministrationAmount,
                    distributionAmount: data.webCalc.distributionAmount
                }
            }
        };
    }

    fetchAsync({data, transactionId}) {
        console.debug("CustomerInfoProvider#fetchAsync");

        try {

            const payload = CustomerInfoProvider.createPayload(data);

            const hash = JSON.stringify(payload);
            const cashedResult = this.cache[hash];

            if (cashedResult) {
                return Promise.resolve(cashedResult);
            }

            return Api.fetchCustomerInfoDocsAsync(payload, transactionId)
                .then(documents => {

                    this.cache[hash] = documents;

                    return documents;
                });

        } catch (e) {

            return Promise.reject(e);
        }
    }


}

export {CustomerInfoProvider};